import React from "react";
import { GroupDto } from "../../../Types/GroupServiceTypes";
import { Card, CardHeader, CardTitle, CardContent } from "../../../Components/Card";
import { AdminIcon } from "../../../Icons/AdminIcon";
import { Button } from "../../../Components/Button";
import { Badge } from "../../../Components/Badge";
import '../AdminGroups.css'

interface Props {
  group: GroupDto;
  onOpen: () => void;
  onRefresh: () => void;
}
 const getStatusColor = (status: string) => {
    switch (status) {
      case 'joined': return 'admingroups-statuscolor-joined';
      case 'invited': return 'admingroups-statuscolor-invited';
      case 'pending': return 'admingroups-statuscolor-pending';
      default: return 'admingroups-statuscolor-default';
    }
  };
const GroupCard: React.FC<Props> = ({ group, onOpen }) => {
  return (
    <Card disableHover>
      <CardHeader className="admin-groups-tab-content-card-header">
        <div>
          <CardTitle className="admin-groups-tab-content-card-title-container">
            <AdminIcon.UserGroup fill="hsl(var(--primary))" />
            {group.name}
          </CardTitle>
          <p className="admin-groups-tab-content-card-title-paragraph-one">{group.description}</p>
          <p className="admin-groups-tab-content-card-title-paragraph-two">Skapad: {group.createdAt}</p>
        </div>

        <div className="admin-groups-tab-content-card-buttons-container">
          <Button className="submit-button" style={{ cursor: "pointer" }} onClick={onOpen} text={<AdminIcon.EditPencil width={20} height={20} fill="white" />} />
        </div>
      </CardHeader>

      <CardContent>
        <div className="admin-groups-groupcard-margin">
          <h4 className="admin-groups-font-medium mb-2">Medlemmar ({group.users.length})</h4>
          <div className="admin-groups-space-y-2">
            {group.users.slice(0,3).map(u => (
              <div key={u.id} className="admin-groups-flex-items-center-justify-between-p-2-bg-gray-50-rounded">
                <div className="flex-items-center-gap-3">
                  <div>
                    <p className="text-sm-font-medium">{u.name}</p>
                    <p className="text-xs-text-gray-500">{u.email}</p>
                  </div>
                </div>
                <div className="flex-items-center-gap-2">
                  <Badge className={getStatusColor(u.status)}>{u.status}</Badge>
                </div>
              </div>
            ))}
            {group.users.length > 3 && <p className="text-xs-text-gray-500">+{group.users.length - 3} fler</p>}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default GroupCard;
